module.exports = __webpack_public_path__ + "img/bg-figure.240b3d60.svg";